import i18n from '@/plugins/i18n'

export default {
    name: 'HelloWorld',
    data: () => {
        return {
            langCode: 'tr',
            languages: Object.values(i18n.messages),
            ctpServiceURI: "",
            username: "",
            password: "",
            forgotPasswordMailBody: ""
        }
    },
    created: function() {
        this.langCode = localStorage.getItem("lang") === undefined || localStorage.getItem("lang") === null ? 'tr' : localStorage.getItem("lang");
    },
    methods: {

        changeLang() {
            let that = this;
            localStorage.setItem("lang", that.langCode);
            location.reload();
        },
        async login() {
            let that = this;
            if (this.username && this.password) {
            that.loaderShow();
                var res = await that.getData(this.urls.service + '/api/authentication/Login?code=' + this.username + '&password=' + this.password);
                localStorage.setItem('ctpToken',res.token);
                console.log('login res');
                // console.log(res);

                if (res.isError === false) {
                    that.userData = res.data.Item1;
                    localStorage.setItem('userData', JSON.stringify(that.userData));

                    res = await that.getData(this.urls.service + '/api/data/usercompany?user_id=' + this.userData.id);
                    that.userCompanyList = res.data;
                    that.userCompanyList.unshift({ id: null, title: 'Tümü' });
                    localStorage.setItem('userCompanyList', JSON.stringify(that.userCompanyList));

                    if(that.username.toLowerCase() ==='betek'){ 
                        that.$router.push({ name: 'Order' });
                    } else {
                        that.$router.push({ name: 'Order' });
                    }

                    location.reload();
                } else {
                    alert(res.message);
                }
                that.loaderHide();




                // fetch(uri).then((res) => res.json()).then((res) => {
                //     that.userData = res;
                //     if (that.userData.errorMessage == "") {
                //         //redirect
                //         // alert(i18n.t('loginOperationSuccessMsg'));

                //         this.$session.start();
                //         this.$session.set('userData', that.userData);
                //         localStorage.setItem('userData', JSON.stringify(that.userData));

                //         debugger;
                //         this.$router.push({ name: 'Dashboard' });
                //         location.reload();
                //         // document.querySelector('#content').style.width = "100%";

                //     } else {

                //         alert(i18n.t('loginOperationFailureMsg') + ' | ' + that.userData.errorMessage);

                //     }
                // }).catch((err) => {
                //     return err;
                // });
            } else {
                alert(i18n.t('cantLeaveUsernameOrPasswordEmptyWarning'));
            }
        },
        forgotPassword() {
            if (this.forgotPasswordMailBody != "") {


                let uri = this.ctpServiceURI + 'api/authentication/ForgotPassword?ForgotPasswordMailBody=' + this.forgotPasswordMailBody;

                fetch(uri).then((res) => res.json()).then((res) => {
                    if (res.errorMessage == "") {
                        alert(i18n.t('forgotPasswordOperationSuccessMsg'));
                        location.reload();
                    } else {
                        alert(i18n.t('forgotPasswordOperationFailureMsg') + ' | ' + res.errorMessage);
                    }
                }).catch((err) => {
                    return err;
                });
            } else {
                alert(i18n.t('cantLeaveForgotPasswordTextEmptyWarning'));
            }
        }
    }
}